export const STATE = {
    success: 'success',
    error: 'error',
    focus: 'focus',
    default: 'default',
};
export const VARIANT = {
    compact: 'compact',
    default: 'default',
};
export const TYPE = {
    text: 'text',
    number: 'number',
    password: 'password',
    tel: 'tel',
};
